import React, { Component, useEffect } from "react";
import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Breadcrumb } from "@gull";
import { Formik } from "formik";

import { useState } from "react";

import * as yup from "yup";
import { RenderTextInput } from "app/common/renderInput";
import { getRoles } from "app/services/permissionService";
import { addUserData } from "app/services/UserService";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";

const model = {
  firstName: "",
  lastName: "",

  username: "",
  userEmail: "",
  phoneNumber: "",
  address: "",
  password: "",
  roleId: 0,
};

const validationModel = yup.object().shape({
  firstName: yup.string().required("First name is required!"),
  lastName: yup.string().required("Last name is required!"),

  username: yup.string().required("User name is required!"),
  userEmail: yup
    .string()
    .email("Please enter valid email")
    .required("Email is required!"),
  phoneNumber: yup
    .string()
    .min(6, "Minimum 6 digits are required")
    .max(10, "Maximum 10 digits allowed")
    .required("phoneNumber is required!"),
  password: yup.string().required("Password is required!"),
  address: yup.string().required("Address is required!"),
  roleId: yup.number().required("Role is required!"),
});
export { model, validationModel };

function AddUser() {
  const Navigate = useNavigate();

  const [state, setState] = useState(model);
  const [roleData, setRoleData] = useState([]);

  const loadRoles = async () => {
    const response = await getRoles();

    const data = response.data;

    const demo = {
      roleId: 0,
      roleName: "---Select Role---",
      description: "",
      isLocked: false,
      userCount: "",
    };
    setRoleData((x) => [demo, ...data]);
  };
  useEffect(() => {
    loadRoles();
  }, []);
  const addUserHandler = async (values, { resetForm }) => {
    // console.log(values);
    const formatterValue = { ...values, email: values.userEmail };

    const res = await addUserData(formatterValue);
    // console.log(res);
    if (res.status == "Success") {
      NotificationManager.success(res.message);
      resetForm({ values: "" });
      Navigate("/admin/users/users");
    } else {
      NotificationManager.error(res.message);
    }
  };
  return (
    <div>
      <Helmet>
        <title>Add User</title>
      </Helmet>

      <Breadcrumb
        routeSegments={[
          { name: "Users", path: "/admin/bank/bank-lists" },
          { name: "Add User" },
        ]}
      ></Breadcrumb>

      {/* <Card className="m-auto pl-4 pt-4" style={{ width: "100%" }}> */}
      <Card className="p-4">
        <Formik
          initialValues={state}
          validationSchema={validationModel}
          onSubmit={addUserHandler}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            isValid,
            dirty,
            setFieldValue,
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="firstName"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        First name
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        className={
                          touched.firstName && errors.firstName
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="FirstName"
                        value={values.firstName}
                        error={errors.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.firstName}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="lastName"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Last name
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        className={
                          touched.lastName && errors.lastName
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Email"
                        value={values.lastName}
                        error={errors.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.lastName}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="username"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        User name
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="username"
                        id="username"
                        className={
                          touched.username && errors.username
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Bank Name"
                        value={values.username}
                        error={errors.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.username}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="accountNumber"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Email
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="userEmail"
                        className={
                          touched.userEmail && errors.userEmail
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Email"
                        value={values.userEmail}
                        error={errors.userEmail}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.userEmail}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Phone No.
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="phoneNumber"
                        className={
                          touched.phoneNumber && errors.phoneNumber
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Mobile no."
                        value={values.phoneNumber}
                        error={errors.phoneNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.phoneNumber}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="password"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Password
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type={values.password ? "password" : "text"}
                        name="password"
                        id="password"
                        className={
                          touched.password && errors.password
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="password"
                        value={values.password}
                        error={errors.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.password}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        htmlFor="address"
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Address
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="address"
                        id="address"
                        className={
                          touched.address && errors.address
                            ? "error form-control customInput"
                            : "form-control customInput"
                        }
                        placeholder="Address"
                        value={values.address}
                        error={errors.address}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {errors.address}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group">
                      <label
                        className="font-weight-bold"
                        style={{ fontSize: "15px" }}
                      >
                        Role
                      </label>
                      <select
                        className="form-select mb-3"
                        aria-label="Default select example"
                        value={values.roleId}
                        error={errors.roleId}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setFieldValue("roleId", e.target.value);
                        }}
                      >
                        {roleData.map((x) => (
                          <option value={x.roleId} key={x.roleId}>
                            {x.roleName}
                          </option>
                        ))}
                      </select>

                      <p className="text-danger" style={{ fontSize: "10px" }}>
                        {touched.roleId && errors.roleId}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 mb-3">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </Card>
    </div>
  );
}

export default AddUser;
